import type { UserResponse } from 'types/session/user'
import { StatusCode } from 'types/statusCodes'
import { env } from 'utils/envManager'
import { url } from 'utils/url'

import type {
	RegistryServiceFieldsError,
	RegistryServiceParams,
} from '../types/registryService'

const REGISTRY_SERVICE_ENDPOINT = url(
	`${env.NEXT_PUBLIC_SITE_BASE_URL}/ws-online-customer-service/customer/v3/signon`
)

export const registryService = async (
	payload: RegistryServiceParams
): Promise<UserResponse | RegistryServiceFieldsError | null> => {
	const response = await fetch(REGISTRY_SERVICE_ENDPOINT, {
		headers: { 'Content-Type': 'application/json' },
		method: 'POST',
		body: JSON.stringify(payload),
		next: { revalidate: 0 },
	})

	if (response.ok || response.status === StatusCode.BAD_REQUEST) {
		return response.json()
	}

	console.error(`Registry service error with status ${response.status}.`)
	return null
}
